exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --jumbotron-padding-y: 3rem;\n}\n\n\n\nfooter {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\nfooter p {\n  margin-bottom: .25rem;\n}\n\n.navbar-tg {\n  background-color: #fff !important;\n  border-bottom: 18px solid #0071b7;\n}\n\n.box-shadow { box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .05); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/m.altmann/Documents/Projekte/telegärtner/tg-pwa/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main